import { DEFAULT_PET_POISON_HOTLINE_PRICE } from '@/constants/athena-toggle-names';
import { useFeatureValue } from '@/hooks/useFeatureValue';
import { FeatureConfigKeys } from '@/utils/athena-feature-config';

export const usePetPoisonHotlinePrice = (): string => {
  const price = useFeatureValue(
    FeatureConfigKeys.PET_POISON_HOTLINE_PRICE,
    DEFAULT_PET_POISON_HOTLINE_PRICE,
  );
  const normalizedPrice =
    typeof price === 'string' || typeof price === 'number' ? String(price).trim() : '';
  const amount = Number(normalizedPrice);

  return Number.isFinite(amount) && amount > 0 ? normalizedPrice : DEFAULT_PET_POISON_HOTLINE_PRICE;
};
